import React, {Component} from 'react';
import {connect} from "react-redux";
import {withTranslation} from 'react-i18next';


@connect((store) => {
    return {
        chatprop: store.chatprop
    };
})
class TopBar extends Component {

    constructor(props) {
        super(props);

    }


    render() {
        const {t} = this.props;


        if(this.props.chatprop.operator['away'] ==1){
            return (
                <div className="topBar topBarAway">
                    <span>You are currently not accepting chats.</span>
                </div>
            )
        } else {
            return (
                <React.Fragment>

                </React.Fragment>
            );
        }

    }
}

export default withTranslation()(TopBar);
